
















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import JobCorpsCenter from '@/classes/JobCorpsCenter';
import MaterialForm from '@/classes/MaterialForm';
import { MaterialFormLineItem, IMaterialFormLineItem } from '@/classes/MaterialFormLineItem';
import MaterialCategory from '@/classes/MaterialCategory';
import MaterialItem from '@/classes/MaterialItem';
import BusinessCardForm from '@/components/forms/BusinessCardForm.vue';
import MaterialItemTable from '@/components/MaterialItemTable.vue';
import MaterialItemFormTable from '@/components/MaterialItemFormTable.vue';
import MaterialShipToCenter from '@/components/MaterialShipToCenter.vue';
import MaterialShipToUser from '@/components/MaterialShipToUser.vue';
import authorize, { Office, authorizeMap } from '@/services/Authorize';
import binaryDownload from '@/services/BinaryDownloader';
import { sprintf } from 'sprintf-js';
import 'bootstrap';
import bootbox from 'bootbox';

@Component({
    components: {
        BusinessCardForm,
        MaterialItemTable,
        MaterialItemFormTable,
        MaterialShipToCenter,
        MaterialShipToUser
    }
})
export default  class MaterialRequestForm extends Vue {
    @Prop() public id!: number;
    @Prop({default: false}) public view!: boolean;
    public selectedCategory: number | null = null;
    public selectedItem: number | null = null;
    public materialForm: MaterialForm = new MaterialForm();
    public edit: boolean = false;

    public get category(): MaterialCategory | undefined {
        return this.$store.getters['material/getCategoryById'](this.selectedCategory);
    }

    public created() {
        this.updateForm();
    }

    public updateFormLineItem(item: MaterialItem): void {
        const index: number = this.materialForm.items.findIndex((lineItem: MaterialFormLineItem) => item.id === lineItem.materialItemId);
        if (index > -1) {
            if (item.formQuantity === undefined || (Number(item.formQuantity) <= 0 && item.businessCard === undefined)) {
                this.materialForm.items.splice(index, 1);
            } else {
                this.materialForm.items[index].quantity = Number(item.formQuantity);
                this.materialForm.items[index].businessCard = item.businessCard;
            }
        } else {
            if ( Number(item.formQuantity) !== 0) {
            this.materialForm.items.push(new MaterialFormLineItem(
                {
                    materialItemId: item.id,
                    quantity: item.businessCard === undefined ? Number(item.formQuantity) : 1,
                    businessCard: item.businessCard
                } as IMaterialFormLineItem));
            }
        }
    }

    public matchItemToLineItem(item: MaterialItem): MaterialItem {
        if (this.materialForm !== undefined && this.materialForm.items !== undefined) {
            const index: number = this.materialForm.items.findIndex((lineItem: MaterialFormLineItem) => item.id === lineItem.materialItemId);
            if (index > -1) {
                item.formQuantity = this.materialForm.items[index].quantity;
                item.businessCard = this.materialForm.items[index].businessCard;
                item.setAddedToForm(true);
                return item;
            } else {
                item.setAddedToForm(false);
                return item;
            }
        } else {
            return item;
        }
    }

    public updateForm() {
        if (this.id !== undefined && !isNaN(this.id)) {
            this.edit = true;
            this.$store.dispatch('material/loadMaterialForms', true)
            .then(() => {
                const materialForm: MaterialForm | undefined = this.$store.getters['material/getMaterialFormById'](this.id);
                if (materialForm !== undefined) {
                    this.materialForm = materialForm;
                } else if (this.edit) {
                    alert('Material Request Form was not found.');
                    this.$router.push('/forms');
                }
            });
        }
    }

    get jobCorpCenters(): JobCorpsCenter[] {
        if (authorize(Office)) {
            return this.$store.getters.getJobCorpsCenters;
        } else {
            const centers: number[] =
                this.$store.getters.getActiveProfile ? this.$store.getters.getActiveProfile.jobCorpsCenterIds : [];
            return this.$store.getters.getJobCorpsCenters.filter((s: JobCorpsCenter) => {
                return s.id !== undefined ? centers.includes(s.id) : false;
            });
        }
    }

    public get categories(): MaterialCategory[] {
        const categories: MaterialCategory[] = this.$store.getters['material/getMaterialCategories'];
        if (categories !== undefined) {
            return categories;
        } else {
            return [];
        }
    }

    public get items(): MaterialItem[] {
        const items: MaterialItem[] = this.$store.getters['material/getMaterialItems'];
        if (items !== undefined) {
            if (this.selectedCategory !== null) {
                return items.filter((item: MaterialItem) => item.categoryId === Number(this.selectedCategory)).map(this.matchItemToLineItem);
            } else {
                return [];
            }
        } else {
            return [];
        }
    }

    public get showItems(): boolean {
        return !!this.selectedCategory && 0 < this.items.length;
    }

    public removeFromForm(formItem: MaterialFormLineItem): void {
        const index: number = this.materialForm.items.findIndex((fItem: MaterialFormLineItem) => fItem.materialItemId === formItem.materialItemId);
        if (index > -1) {
            this.materialForm.items.splice(index, 1);
        }
    }

    public get sendToCenter(): boolean {
        return !(this.materialForm.shipToCenterId === -1);
    }

    public checkShipToStudentId(value: string | number) {
        if (Number(value) === -1) {
            this.materialForm.shipToUserId = this.$store.getters.getActiveProfile.id;
        } else {
            this.materialForm.shipToUserId = undefined;

        }
    }

    public checkSubmission(): string | boolean {
        const errors: string [] = [];
        if (this.materialForm.shipToCenterId === null || this.materialForm.shipToCenterId === undefined) {
            errors.push('A desitination must be chosen to ship to.');
        }
        if (this.materialForm.items === null || this.materialForm.items === null || this.materialForm.items.length === 0) {
            errors.push('At least one item must be added to form.');
        }
        if (errors.length > 0) {
            return 'Please correct the following: \n\n' + errors.reduce((a: string, e: string) => a + '\n' + e );
        } else {
            return false;
        }
    }
    public submitForm() {
        if (this.checkSubmission()) {
            alert(this.checkSubmission());
        } else {
            const dispatchString: string = this.edit ? 'material/editMaterialForm' : 'material/addMaterialForm';
            this.$store.dispatch(dispatchString, this.materialForm)
            .then((r: any) => {
                if (!r.success) {
                    alert(r.message);
                } else {
                    alert('Your request has been submitted successfully.');
                    this.updateForm();
                    this.$router.push('/forms/materialrequestform/' + r.form.id);
                }
            })
            .catch((e) => {
                alert(e);
            });
        }
    }

    public get authorizeAction(): boolean {
        let authorized: boolean = false;
        if (this.materialForm.actionLevel !== undefined) {
            authorized = authorize(authorizeMap(this.materialForm.actionLevel));
        }
        return authorized;
    }

    public approve() {
        this.materialForm.action = 'approve';
        this.submitForm();
    }

    public decline() {
        this.materialForm.action = 'decline';
        this.submitForm();
    }

    public saveEdits() {
        this.materialForm.action = 'edit';
        this.submitForm();
    }

    public get approveString(): string {
        if (this.materialForm.actionLevel && this.materialForm.status && this.materialForm.requiresDirectorApproval !== undefined) {
            const actionLevel: string = this.materialForm.actionLevel;
            const status: string = this.materialForm.status;
            const reqDirApprvl: boolean = this.materialForm.requiresDirectorApproval;
            if (status === 'Pending_Review_by_Field_Coordinator') {
                return 'Approve Request';
            } else if (status === 'Pending_Review_by_General_Office' && reqDirApprvl) {
                return 'Approve Request';
            } else {
                return 'Complete Request';
            }
        } else {
            return 'Approve Request';
        }
    }

    public get isCompleted(): boolean {
        let isCompleted = false;
        if (this.materialForm && this.materialForm.status && this.materialForm.status === 'Completed') {
            isCompleted = true;
        }
        return isCompleted;
    }

    private downloadPdf(): void {
        binaryDownload('GET', sprintf('/api/v1/report/material_request/%d', this.id))
            .catch((error) => {
                bootbox.alert(error.message);
            });
    }

    private getItemName(id: number): string {
        const materialItem: MaterialItem | undefined = this.$store.getters['material/getMaterialItemById'](id);
        if (materialItem !== undefined && materialItem.listItem !== undefined && materialItem.quantityOfStock !== undefined) {
            return materialItem.listItem + ' (QTY ' + materialItem.quantityOfStock + ')';
        } else {
            return materialItem && materialItem.listItem ? materialItem.listItem : '';
        }
    }
}
